export var Owner;
(function (Owner) {
    Owner[Owner["PrivatePerson"] = 1] = "PrivatePerson";
    Owner[Owner["Community"] = 2] = "Community";
    Owner[Owner["PrivatePersonOrRelatedParty"] = 3] = "PrivatePersonOrRelatedParty";
    Owner[Owner["CommunityOrRelatedParty"] = 4] = "CommunityOrRelatedParty";
    Owner[Owner["Unknown"] = 5] = "Unknown";
})(Owner || (Owner = {}));
